import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { ContractListItem } from '@app/features/contracts/contract.model';
import { UserIdToUserNamePipe } from '@app/features/users/user-id-to-user-name.pipe';
import { WarningTipsComponent } from '@app/shared/tips/warn-tips/warn-tips.component';

/**
 * Avertissement affiché sur un contrat supprimé logiquement : date, auteur et motif.
 * N'affiche rien tant que le contrat n'est pas supprimé, ce qui permet de le poser
 * inconditionnellement là où un contrat est présenté.
 */
@Component({
  selector: 'app-contract-deleted-warning',
  imports: [CommonModule, WarningTipsComponent, UserIdToUserNamePipe],
  templateUrl: './contract-deleted-warning.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contract-deleted-warning.scss',
})
export class ContractDeletedWarning {
  readonly contract = input.required<ContractListItem>();
}
